<template>
  <div>
    <section aria-labelledby="cart-heading" class="mt-6">
      <h2 id="summary-heading" class="mb-6">{{ $t("order.summary") }}</h2>

      <ul
        role="list"
        class="border-t border-b border-gray-200 divide-y divide-gray-200"
      >
        <li
          v-for="(orderItem, index) in cart.items"
          :key="'orderItem' + index"
          class="flex py-6"
          v-if="orderItem.model.shopItem"
        >
          <div class="flex justify-between">
            <div class="pr-6 text-sm">
              <span class="font-medium text-gray-700 hover:text-gray-800">
                {{ orderItem.quantity }} X {{ orderItem.model.name }}
              </span>
            </div>

            <div class="text-sm font-medium text-gray-900">
              <div class="mb-2">
                {{ $t("invoice.amount") }}
                {{
                  formatPrice(orderItem.price, orderItem.model.currency.symbol)
                }}
              </div>
              <div>
                {{ $t("invoice.vat") }}
                {{
                  moneyFormat(
                    orderItem.price * (orderItem.vat / 100),
                    orderItem.model.currency.symbol
                  )
                }}
              </div>
            </div>
          </div>
        </li>

        <li class="flex py-6">
          <div class="relative flex-1 flex flex-col justify-between">
            <div class="pr-6 text-sm">
              <span class="font-medium text-gray-700 hover:text-gray-800">
                {{ $t("shop.shipping-cost") }}
              </span>
            </div>

            <div class="text-sm font-medium text-gray-900 text-right">
              <div class="mb-2">
                {{ $t("invoice.amount") }}
                {{
                  moneyFormat(
                    cart.shippingCost,
                    orderItem.model.currency.symbol
                  )
                }}
              </div>
              <div>
                {{ $t("invoice.vat") }}
                {{
                  moneyFormat(
                    cart.shippingCostVat,
                    orderItem.model.currency.symbol
                  )
                }}
              </div>
            </div>
          </div>
        </li>
      </ul>
    </section>

    <section
      aria-labelledby="summary-heading"
      class="border-b border-gray-200 divide-y divide-gray-200 mb-6"
    >
      <div class="my-6">
        <dl class="space-y-4 mb-2">
          <div class="flex items-center justify-between">
            <dt class="text-base font-medium text-gray-900">
              {{ $t("cart.subtotal") }}
            </dt>
            <dd class="ml-4 text-base font-medium text-gray-900">
              {{
                moneyFormat(
                  cart.total + cart.shippingCost,
                  orderItem.model.currency.symbol
                )
              }}
            </dd>
          </div>
        </dl>

        <dl class="space-y-4">
          <div class="flex items-center justify-between">
            <dt class="text-base font-medium text-gray-900">
              {{ $t("invoice.vat") }}
            </dt>
            <dd class="ml-4 text-base font-medium text-gray-900">
              {{
                moneyFormat(
                  cart.vat + cart.shippingCostVat,
                  orderItem.model.currency.symbol
                )
              }}
            </dd>
          </div>
        </dl>
      </div>

      <div class="my-6">
        <dl class="space-y-4">
          <div class="flex items-center justify-between">
            <dt class="text-base font-medium text-gray-900">
              {{ $t("invoice.total") }}
            </dt>
            <dd class="ml-4 text-base font-medium text-gray-900">
              {{
                moneyFormat(
                  cart.expectedPayment,
                  orderItem.model.currency.symbol
                )
              }}
            </dd>
          </div>
        </dl>
      </div>
    </section>
  </div>
</template>

<script>

import axios from "axios";

export default {
  props: {
    cart: Object,
  },
  data() {
    return {
      
    };
  },
  methods: {
    formatPrice(value, currency) {
      return number_format(parseFloat(value), 2) + " " + currency;
    },
  },
};
</script>
